import { catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
var GroundingsService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function GroundingsService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    /**
     * Get Groundings list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    GroundingsService.prototype.getList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'groundings', params);
    };
    /**
     * Get an exportation file of all compananies
     *
     * @since 1.0.0
     */
    GroundingsService.prototype.getExport = function () {
        var _this = this;
        return this.apiService.apiCall('GET', 'groundings/export', {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    GroundingsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GroundingsService_Factory() { return new GroundingsService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: GroundingsService, providedIn: "root" });
    return GroundingsService;
}());
export { GroundingsService };
